import type { IFinancialCockpitUserInfo } from '../api/types'

interface ICockpitSessionUser {
  firstName: string
  lastName: string
  email: string
  roleIds: string[]
}

const normalizeCommaSeparatedValue = (value: unknown): string =>
  typeof value === 'string'
    ? value
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
        .join(', ')
    : ''

export const getCockpitUserAccess = (
  userInfo: IFinancialCockpitUserInfo | null,
  user: ICockpitSessionUser
) => {
  const role =
    userInfo?.UserRoleId ||
    ['P360PartnerManager', 'P360SalesManager', 'P360GeoLead'].find((roleId) =>
      user.roleIds.includes(roleId)
    ) ||
    user.roleIds[0] ||
    ''
  const name =
    userInfo?.UserFullName ||
    [user.firstName, user.lastName].filter(Boolean).join(' ') ||
    user.email
  return {
    name,
    firstName: userInfo?.UserFirstName || user.firstName || name,
    role,
    accessRole: userInfo?.AccessRole || role,
    accessLevel: userInfo?.AccessLevel || '',
    accessLevelDetails: normalizeCommaSeparatedValue(userInfo?.AccessLevelDetails),
    accessRtm: normalizeCommaSeparatedValue(userInfo?.AccessRTM),
    accessOfferings: normalizeCommaSeparatedValue(userInfo?.AccessOfferings),
  }
}
